import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import OrderBuilder from './components/OrderBuilder';
import { Nutricion, Recetas, Certificaciones, Galeria, Proceso, Finca, Cobertura, Faq, PescadoBarato, Juego } from './components/Sections';
import Footer from './components/Footer';
import ChatWidget from './components/ChatWidget';
import { Toaster } from './components/ui/toaster';
import { PagoExitoso, PagoCancelado } from './pages/PagoResultado';
import AdminPedidos from './pages/AdminPedidos';
import Clasificacion from './pages/Clasificacion';

const Home = () => (
  <>
    <Header />
    <main id="inicio">
      <Hero />
      <PescadoBarato />
      <OrderBuilder />
      <Nutricion />
      <Recetas />
      <Certificaciones />
      <Galeria />
      <Proceso />
      <Finca />
      <Cobertura />
      <Faq />
      <Juego />
    </main>
    <Footer />
    <ChatWidget />
    <Toaster />
  </>
);

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/pago/exitoso" element={<><PagoExitoso /><Toaster /></>} />
        <Route path="/pago/cancelado" element={<><PagoCancelado /><Toaster /></>} />
        <Route path="/admin" element={<><AdminPedidos /><Toaster /></>} />
        <Route path="/juego" element={<><Clasificacion /><Toaster /></>} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;